export var ToastMessageCategoryEnum;
(function (ToastMessageCategoryEnum) {
    ToastMessageCategoryEnum["Info"] = "info";
    ToastMessageCategoryEnum["Warning"] = "warning";
    ToastMessageCategoryEnum["Error"] = "error";
    ToastMessageCategoryEnum["Success"] = "success";
})(ToastMessageCategoryEnum || (ToastMessageCategoryEnum = {}));
export var ToastMessageAnimationEnum;
(function (ToastMessageAnimationEnum) {
    ToastMessageAnimationEnum["Initial"] = "initial";
    ToastMessageAnimationEnum["Appear"] = "appear";
    ToastMessageAnimationEnum["Idle"] = "idle";
    ToastMessageAnimationEnum["Disappear"] = "disappear";
})(ToastMessageAnimationEnum || (ToastMessageAnimationEnum = {}));
//# sourceMappingURL=toast-message.enum.js.map
